import {
  ISchDModel,
  ITaxBracketModel,
  IStandardDeductionModel,
} from '../types';


// for 2026
const maxSETaxThreshold2026 = 184500;

// for 2025 values most up to date - 2026 not released yet
const schDLineSix2026: ISchDModel[] = [
  { id: 0, filingStatus: 'Single', value: 48350 },
  { id: 1, filingStatus: 'MFJ', value: 96700 },
  { id: 2, filingStatus: 'MFS', value: 48350 },
  { id: 3, filingStatus: 'HOH', value: 64750 },
];

// 2026 values most up to date - 2026 not released yet
const schDLineThirteen2026: ISchDModel[] = [
  { id: 0, filingStatus: 'Single', value: 533400 },
  { id: 1, filingStatus: 'MFJ', value: 600050 },
  { id: 2, filingStatus: 'MFS', value: 300000 },
  { id: 3, filingStatus: 'HOH', value: 566700 },
];

// 2026
const federalStandardDeduction2026: IStandardDeductionModel[] = [
  { id: 0, standardDeduction: -16100, filingStatus: 'Single' },
  { id: 1, standardDeduction: -16100, filingStatus: 'MFS' },
  { id: 2, standardDeduction: -32200, filingStatus: 'MFJ' },
  { id: 3, standardDeduction: -24150, filingStatus: 'HOH' },
];

// 2025
const newYorkStandardDeduction2026: IStandardDeductionModel[] = [
  { id: 0, standardDeduction: -8000, filingStatus: 'Single' },
  { id: 1, standardDeduction: -8000, filingStatus: 'MFS' },
  { id: 2, standardDeduction: -16050, filingStatus: 'MFJ' },
  { id: 3, standardDeduction: -11200, filingStatus: 'HOH' },
];


// FEDERAL 2026

const federalSingleTaxBrackets2026: ITaxBracketModel[] = [
  { id: 0, bracket: '10%', rate: 0.1, totalTaxBelowBracket: 0, taxBracketFloor: undefined, taxBracketCeiling: 12400 },
  { id: 1, bracket: '12%', rate: 0.12, totalTaxBelowBracket: 1240, taxBracketFloor: 12401, taxBracketCeiling: 50400 },
  { id: 2, bracket: '22%', rate: 0.22, totalTaxBelowBracket: 5800, taxBracketFloor: 50401, taxBracketCeiling: 105700 },
  { id: 3, bracket: '24%', rate: 0.24, totalTaxBelowBracket: 17966, taxBracketFloor: 105701, taxBracketCeiling: 201775 },
  { id: 4, bracket: '32%', rate: 0.32, totalTaxBelowBracket: 41024, taxBracketFloor: 201776, taxBracketCeiling: 256225 },
  { id: 5, bracket: '35%', rate: 0.35, totalTaxBelowBracket: 58448, taxBracketFloor: 256226, taxBracketCeiling: 640600 },
  { id: 6, bracket: '37%', rate: 0.37, totalTaxBelowBracket: 192979, taxBracketFloor: 640601, taxBracketCeiling: undefined },
];

const federalMFJTaxBrackets2026: ITaxBracketModel[] = [
  { id: 0, bracket: '10%', rate: 0.1, totalTaxBelowBracket: 0, taxBracketFloor: undefined, taxBracketCeiling: 24800 },
  { id: 1, bracket: '12%', rate: 0.12, totalTaxBelowBracket: 2480, taxBracketFloor: 24801, taxBracketCeiling: 100800 },
  { id: 2, bracket: '22%', rate: 0.22, totalTaxBelowBracket: 11600, taxBracketFloor: 100801, taxBracketCeiling: 211400 },
  { id: 3, bracket: '24%', rate: 0.24, totalTaxBelowBracket: 35932, taxBracketFloor: 211401, taxBracketCeiling: 403550 },
  { id: 4, bracket: '32%', rate: 0.32, totalTaxBelowBracket: 82048, taxBracketFloor: 403551, taxBracketCeiling: 512450 },
  { id: 5, bracket: '35%', rate: 0.35, totalTaxBelowBracket: 116896, taxBracketFloor: 512451, taxBracketCeiling: 768700 },
  { id: 6, bracket: '37%', rate: 0.37, totalTaxBelowBracket: 206584, taxBracketFloor: 768701, taxBracketCeiling: undefined },
];

const federalMFSTaxBrackets2026: ITaxBracketModel[] = [
  { id: 0, bracket: '10%', rate: 0.1, totalTaxBelowBracket: 0, taxBracketFloor: undefined, taxBracketCeiling: 12400 },
  { id: 1, bracket: '12%', rate: 0.12, totalTaxBelowBracket: 1240, taxBracketFloor: 12401, taxBracketCeiling: 50400 },
  { id: 2, bracket: '22%', rate: 0.22, totalTaxBelowBracket: 5800, taxBracketFloor: 50401, taxBracketCeiling: 105700 },
  { id: 3, bracket: '24%', rate: 0.24, totalTaxBelowBracket: 17966, taxBracketFloor: 105701, taxBracketCeiling: 201775 },
  { id: 4, bracket: '32%', rate: 0.32, totalTaxBelowBracket: 41024, taxBracketFloor: 201776, taxBracketCeiling: 256225 },
  { id: 5, bracket: '35%', rate: 0.35, totalTaxBelowBracket: 58448, taxBracketFloor: 256226, taxBracketCeiling: 384350 },
  { id: 6, bracket: '37%', rate: 0.37, totalTaxBelowBracket: 103292, taxBracketFloor: 384351, taxBracketCeiling: undefined },
];

const federalHOHTaxBrackets2026: ITaxBracketModel[] = [
  { id: 0, bracket: '10%', rate: 0.1, totalTaxBelowBracket: 0, taxBracketFloor: undefined, taxBracketCeiling: 17700 },
  { id: 1, bracket: '12%', rate: 0.12, totalTaxBelowBracket: 1770, taxBracketFloor: 17701, taxBracketCeiling: 67450 },
  { id: 2, bracket: '22%', rate: 0.22, totalTaxBelowBracket: 7740, taxBracketFloor: 67451, taxBracketCeiling: 105700 },
  { id: 3, bracket: '24%', rate: 0.24, totalTaxBelowBracket: 16155, taxBracketFloor: 105701, taxBracketCeiling: 201775 },
  { id: 4, bracket: '32%', rate: 0.32, totalTaxBelowBracket: 39213, taxBracketFloor: 201776, taxBracketCeiling: 256200 },
  { id: 5, bracket: '35%', rate: 0.35, totalTaxBelowBracket: 56629, taxBracketFloor: 256201, taxBracketCeiling: 640600 },
  { id: 6, bracket: '37%', rate: 0.37, totalTaxBelowBracket: 191169, taxBracketFloor: 640601, taxBracketCeiling: undefined },
];

const newYorkStateSingleTaxBrackets2026: ITaxBracketModel[] = [
  { id: 0, bracket: '4%', rate: 0.04, totalTaxBelowBracket: 0, taxBracketFloor: undefined, taxBracketCeiling: 8500 },
  { id: 1, bracket: '4.5%', rate: 0.045, totalTaxBelowBracket: 340, taxBracketFloor: 8501, taxBracketCeiling: 11700 },
  { id: 2, bracket: '5.25%', rate: 0.0525, totalTaxBelowBracket: 484, taxBracketFloor: 11701, taxBracketCeiling: 13900 },
  { id: 3, bracket: '5.5%', rate: 0.055, totalTaxBelowBracket: 600, taxBracketFloor: 13901, taxBracketCeiling: 80650 },
  { id: 4, bracket: '6.0%', rate: 0.06, totalTaxBelowBracket: 4271, taxBracketFloor: 80651, taxBracketCeiling: 215400 },
  { id: 5, bracket: '6.85%', rate: 0.0685, totalTaxBelowBracket: 12356, taxBracketFloor: 215401, taxBracketCeiling: 1077550 },
  { id: 6, bracket: '9.65%', rate: 0.0965, totalTaxBelowBracket: 71413, taxBracketFloor: 1077551, taxBracketCeiling: 5000000 },
  { id: 7, bracket: '10.3%', rate: 0.103, totalTaxBelowBracket: 449929, taxBracketFloor: 5000001, taxBracketCeiling: 25000000 },
  { id: 8, bracket: '10.9%', rate: 0.109, totalTaxBelowBracket: 2509929, taxBracketFloor: 25000001, taxBracketCeiling: undefined },
];

const newYorkStateMFJTaxBrackets2026: ITaxBracketModel[] = [
  { id: 0, bracket: '4%', rate: 0.04, totalTaxBelowBracket: 0, taxBracketFloor: undefined, taxBracketCeiling: 17150 },
  { id: 1, bracket: '4.5%', rate: 0.045, totalTaxBelowBracket: 686, taxBracketFloor: 17151, taxBracketCeiling: 23600 },
  { id: 2, bracket: '5.25%', rate: 0.0525, totalTaxBelowBracket: 976, taxBracketFloor: 23601, taxBracketCeiling: 27900 },
  { id: 3, bracket: '5.5%', rate: 0.055, totalTaxBelowBracket: 1202, taxBracketFloor: 27901, taxBracketCeiling: 161550 },
  { id: 4, bracket: '6.0%', rate: 0.06, totalTaxBelowBracket: 8553, taxBracketFloor: 161551, taxBracketCeiling: 323200 },
  { id: 5, bracket: '6.85%', rate: 0.0685, totalTaxBelowBracket: 18252, taxBracketFloor: 323201, taxBracketCeiling: 2155350 },
  { id: 6, bracket: '9.65%', rate: 0.0965, totalTaxBelowBracket: 143754, taxBracketFloor: 2155351, taxBracketCeiling: 5000000 },
  { id: 7, bracket: '10.3%', rate: 0.103, totalTaxBelowBracket: 418263, taxBracketFloor: 5000001, taxBracketCeiling: 25000000 },
  { id: 8, bracket: '10.9%', rate: 0.109, totalTaxBelowBracket: 2478263, taxBracketFloor: 25000001, taxBracketCeiling: undefined },
];

const newYorkStateMFSTaxBrackets2026: ITaxBracketModel[] = [
  { id: 0, bracket: '4%', rate: 0.04, totalTaxBelowBracket: 0, taxBracketFloor: undefined, taxBracketCeiling: 8500 },
  { id: 1, bracket: '4.5%', rate: 0.045, totalTaxBelowBracket: 340, taxBracketFloor: 8501, taxBracketCeiling: 11700 },
  { id: 2, bracket: '5.25%', rate: 0.0525, totalTaxBelowBracket: 484, taxBracketFloor: 11701, taxBracketCeiling: 13900 },
  { id: 3, bracket: '5.5%', rate: 0.055, totalTaxBelowBracket: 600, taxBracketFloor: 13901, taxBracketCeiling: 80650 },
  { id: 4, bracket: '6.0%', rate: 0.06, totalTaxBelowBracket: 4271, taxBracketFloor: 80651, taxBracketCeiling: 215400 },
  { id: 5, bracket: '6.85%', rate: 0.0685, totalTaxBelowBracket: 12356, taxBracketFloor: 215401, taxBracketCeiling: 1077550 },
  { id: 6, bracket: '9.65%', rate: 0.0965, totalTaxBelowBracket: 71413, taxBracketFloor: 1077551, taxBracketCeiling: 5000000 },
  { id: 7, bracket: '10.3%', rate: 0.103, totalTaxBelowBracket: 449929, taxBracketFloor: 5000001, taxBracketCeiling: 25000000 },
  { id: 8, bracket: '10.9%', rate: 0.109, totalTaxBelowBracket: 2509929, taxBracketFloor: 25000001, taxBracketCeiling: undefined },
];

const newYorkStateHOHTaxBrackets2026: ITaxBracketModel[] = [
  { id: 0, bracket: '4%', rate: 0.04, totalTaxBelowBracket: 0, taxBracketFloor: undefined, taxBracketCeiling: 12800 },
  { id: 1, bracket: '4.5%', rate: 0.045, totalTaxBelowBracket: 512, taxBracketFloor: 12801, taxBracketCeiling: 17650 },
  { id: 2, bracket: '5.25%', rate: 0.0525, totalTaxBelowBracket: 730, taxBracketFloor: 17651, taxBracketCeiling: 20900 },
  { id: 3, bracket: '5.5%', rate: 0.055, totalTaxBelowBracket: 901, taxBracketFloor: 20901, taxBracketCeiling: 107650 },
  { id: 4, bracket: '6.0%', rate: 0.06, totalTaxBelowBracket: 5672, taxBracketFloor: 107651, taxBracketCeiling: 269300 },
  { id: 5, bracket: '6.85%', rate: 0.0685, totalTaxBelowBracket: 15371, taxBracketFloor: 269301, taxBracketCeiling: 1616450 },
  { id: 6, bracket: '9.65%', rate: 0.0965, totalTaxBelowBracket: 107651, taxBracketFloor: 1616451, taxBracketCeiling: 5000000 },
  { id: 7, bracket: '10.3%', rate: 0.103, totalTaxBelowBracket: 434163, taxBracketFloor: 5000001, taxBracketCeiling: 25000000 },
  { id: 8, bracket: '10.9%', rate: 0.109, totalTaxBelowBracket: 2494163, taxBracketFloor: 25000001, taxBracketCeiling: undefined },
];

const newYorkCitySingleTaxBrackets2026: ITaxBracketModel[] = [
  { id: 0, bracket: '3.078%', rate: 0.03078, totalTaxBelowBracket: 0, taxBracketFloor: undefined, taxBracketCeiling: 12000 },
  { id: 1, bracket: '3.762%', rate: 0.03762, totalTaxBelowBracket: 369, taxBracketFloor: 12001, taxBracketCeiling: 25000 },
  { id: 2, bracket: '3.819%', rate: 0.03819, totalTaxBelowBracket: 858, taxBracketFloor: 25001, taxBracketCeiling: 50000 },
  { id: 3, bracket: '3.876%', rate: 0.03876, totalTaxBelowBracket: 1813, taxBracketFloor: 50001, taxBracketCeiling: undefined },
];

const newYorkCityMFJTaxBrackets2026: ITaxBracketModel[] = [
  { id: 0, bracket: '3.078%', rate: 0.03078, totalTaxBelowBracket: 0, taxBracketFloor: undefined, taxBracketCeiling: 21600 },
  { id: 1, bracket: '3.762%', rate: 0.03762, totalTaxBelowBracket: 665, taxBracketFloor: 21601, taxBracketCeiling: 45000 },
  { id: 2, bracket: '3.819%', rate: 0.03819, totalTaxBelowBracket: 1545, taxBracketFloor: 45001, taxBracketCeiling: 90000 },
  { id: 3, bracket: '3.876%', rate: 0.03876, totalTaxBelowBracket: 3264, taxBracketFloor: 90001, taxBracketCeiling: undefined },
];

const newYorkCityMFSTaxBrackets2026: ITaxBracketModel[] = [
  { id: 0, bracket: '3.078%', rate: 0.03078, totalTaxBelowBracket: 0, taxBracketFloor: undefined, taxBracketCeiling: 12000 },
  { id: 1, bracket: '3.762%', rate: 0.03762, totalTaxBelowBracket: 369, taxBracketFloor: 12001, taxBracketCeiling: 25000 },
  { id: 2, bracket: '3.819%', rate: 0.03819, totalTaxBelowBracket: 858, taxBracketFloor: 25001, taxBracketCeiling: 50000 },
  { id: 3, bracket: '3.876%', rate: 0.03876, totalTaxBelowBracket: 1813, taxBracketFloor: 50001, taxBracketCeiling: undefined },
];

const newYorkCityHOHTaxBrackets2026: ITaxBracketModel[] = [
  { id: 0, bracket: '3.078%', rate: 0.03078, totalTaxBelowBracket: 0, taxBracketFloor: undefined, taxBracketCeiling: 14400 },
  { id: 1, bracket: '3.762%', rate: 0.03762, totalTaxBelowBracket: 443, taxBracketFloor: 14401, taxBracketCeiling: 30000 },
  { id: 2, bracket: '3.819%', rate: 0.03819, totalTaxBelowBracket: 1030, taxBracketFloor: 30001, taxBracketCeiling: 60000 },
  { id: 3, bracket: '3.876%', rate: 0.03876, totalTaxBelowBracket: 2176, taxBracketFloor: 60001, taxBracketCeiling: undefined },
];

export {
  maxSETaxThreshold2026,
  schDLineSix2026,
  schDLineThirteen2026,
  federalSingleTaxBrackets2026,
  federalMFJTaxBrackets2026,
  federalMFSTaxBrackets2026,
  federalHOHTaxBrackets2026,
  newYorkStateSingleTaxBrackets2026,
  newYorkStateMFJTaxBrackets2026,
  newYorkStateMFSTaxBrackets2026,
  newYorkStateHOHTaxBrackets2026,
  newYorkCitySingleTaxBrackets2026,
  newYorkCityMFJTaxBrackets2026,
  newYorkCityMFSTaxBrackets2026,
  newYorkCityHOHTaxBrackets2026,
  federalStandardDeduction2026,
  newYorkStandardDeduction2026,
};

// will need to make a note about what the tax assumptions button does, updates the following values year by year, se threshold, sch d worksheet, IRS, NY, NYC rates but
// does not include itemized deductions limits such as agi limitations, agi percentages, can I address that too
// make note, values are to date as of this date and are as most up to date as possible, sometimes there will be differences as laws and rates change
